import { render } from "./packseven.vue?vue&type=template&id=8cf5bbc2&scoped=true"
import script from "./packseven.vue?vue&type=script&lang=js"
export * from "./packseven.vue?vue&type=script&lang=js"

import "./packseven.vue?vue&type=style&index=0&id=8cf5bbc2&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf5bbc2"]])

export default __exports__